export default __webpack_public_path__ + "static/media/quality.e101c6d6.svg";